import { UserState } from '../reducers/user.reducer';

export const currentUser = (state: UserState) => state.currentUser;
